module.exports = __webpack_public_path__ + "img/badge-highest-lead-quality-keyvue-blue.e2b565ec.png";